import ReactDOM from 'react-dom/client';
import store from "../src/Store/Store";
import App from './App';
import './index.css';
import "./i18n";

import { Provider } from 'react-redux';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

